// extracted by mini-css-extract-plugin
export var icon = "_6g-1";
export var subtext = "_6g-0";